import { Button, message, Upload, UploadFile } from 'antd';
import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'app/store';
import { updatePageLoadingApi } from '@slice/select.slice';
import { ThunkDispatch } from '@reduxjs/toolkit';
import OrderManagerApi from 'apis/api/OrderManager';
import { useTranslation } from 'react-i18next';
import ModalViewImages from './ModalViewImages';
import ModalUpdateImages from './ModalUpdateImages';
import { ORDER_IMAGE_KIND_LABEL } from './orderImageUtils';

const getBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
export default function ViewImages(data) {
  const { t } = useTranslation();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModalView, setOpenModalView] = useState<boolean>(false);
  const rowSelected = useSelector((state: RootState) => state.orderManager.orderSelect);
  const [images1, setImages1] = useState<any>();
  const [listHinh, setListHinh] = useState<UploadFile[]>([]);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const [listHinhNew, setListHinhNew] = useState<UploadFile[]>([]);

  const handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setImages1(file);
    setPreviewOpen(true);
    setOpenModalView(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };
  // console.log(previewImage.split('data:image/png;base64,').join(''));
  const handleUpload = ({ file, fileList }) => {
    setListHinhNew([...fileList]);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  // cần sửa lại này
  const getListImages = async () => {
    const arrayValue = [];
    for (let i = 0; i < data.data.images?.length; i++) {
      arrayValue.push({
        uid: data.data.images[i].id,
        name: data.data.images[i].comment,
        status: 'done',
        url: process.env.REACT_APP_URL_AUTH + data.data.images[i].link
      });
      // setListHinh(oldValue => {
      //   console.log(oldValue);
      //   return [
      //     ...oldValue,
      //     {
      //       uid: data.data.images[i].id,
      //       name: data.data.images[i].comment,
      //       status: 'done',
      //       url: process.env.REACT_APP_URL_AUTH + data.data.images[i].link
      //     }
      //   ];
      // });
    }
    setListHinh(arrayValue);
  };

  useEffect(() => {
    getListImages();
  }, [data]);

  if (!listHinh?.length) return null;

  return (
    <div className="flex flex-col gap-1 min-w-0 z-50">
      <div className="text-[12px] font-semibold text-gray-600">
        {ORDER_IMAGE_KIND_LABEL.tech} ({listHinh.length})
      </div>
      {openModalView && (
        <ModalViewImages
          isOpen={openModalView}
          base64={previewImage}
          listHinh={listHinh}
          listHinhNew={listHinhNew}
          data={data}
          images1={images1}
          status={data.status}
          callBackClose={() => setOpenModalView(false)}
          //   callBackRefresh={callBackRefresh}
          // callBackCreate={callBackCreate}
        />
      )}

      {openModal && (
        <ModalUpdateImages
          isOpen={openModal}
          base64={previewImage}
          listHinh={listHinh}
          data={data}
          status={data.status}
          callBackClose={() => setOpenModal(false)}
          //   callBackRefresh={callBackRefresh}
          // callBackCreate={callBackCreate}
        />
      )}
      <div className="flex flex-wrap items-center gap-2 min-w-0">
        <Upload
          onPreview={handlePreview}
          onChange={handleUpload}
          showUploadList={{ showRemoveIcon: false }}
          listType="picture-card"
          fileList={listHinh.slice(0, 3)}
        />

        {listHinh.length > 3 && (
          <Button
            type="primary"
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              handleOpenModal();
            }}
          >
            {`+${listHinh.length - 3} Ảnh`}
          </Button>
        )}
      </div>
    </div>
  );
}
